import type { DogBreederLastConnectedTypeEnum } from '@gql/graphql';
import type { LocationDescriptor } from 'history';
import type { HTMLAttributes, MouseEventHandler } from 'react';

export interface CardItemBreederData {
  image?: string;
  hasLitters?: boolean;
  name?: string;
  location?: string;
  breeds?: string;
  languages?: string;
  rating?: {
    amount: number;
    average: number;
  };
  link?: LocationDescriptor;
  onClick?: MouseEventHandler;
  lastConnectedBadgeType?: DogBreederLastConnectedTypeEnum;
  loading?: boolean;
  lazyLoadImage?: boolean;
  useHeadingForTitle?: boolean;
  dogsPedigree?: string | null;
  breedClubValidated?: boolean | null;
}

export interface CardItemBreederProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'onClick'>,
    CardItemBreederData {}
